import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { StudentVerificationService } from '../student-verification.service';
import { ActivatedRoute } from '@angular/router';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-student-verification',
  templateUrl: './student-verification.component.html',
  styleUrls: ['./student-verification.component.scss']
})
export class StudentVerificationComponent implements OnInit {
  student: any;
  studentdetials: any;
  studentname: any;
  saveDetails: any;
  refValue: any;
  refId: string | null = null;
  errValue: boolean = false;
  invalidLink: boolean = false;
  studentHallTicketName: any;
  hallTIcketerror: any=false;
  saveButton: any=false;
  constructor(private verification: StudentVerificationService, private spinner: NgxSpinnerService, private fb: FormBuilder, private toast: ToastmessageService, private route: ActivatedRoute, private dialog: MatDialog) {
    this.student = this.fb.group({
      AdmNo: ["", Validators.required],
      Mobilenumber: ["", Validators.required],
      hallticketnumber: ["", Validators.required],

    })
    this.student.get('Mobilenumber')?.valueChanges.subscribe((value: any) => {
      if (value?.length === 4) {
        const admNo = this.student.get('AdmNo')?.value;
        const mobile = value;

        if (admNo) {
          this.callApiWithAdmNoAndMobile(admNo, mobile);
        }
      }
    });
  this.student.get("hallticketnumber").valueChanges.subscribe((value:any)=>{
    if(value.length==10){
      this.gethtticket(value);
    }
  })
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.refId = params['refId'];
      console.log('refId from query params:', this.refId);
    });
    this.getHtNoVerification();
  }

  getHtNoVerification() {
    this.spinner.show();
    this.verification.getRefverification(this.refId).subscribe(
      {
        next: (res: any) => {
          if (res === 'idExist') {
            this.errValue = true;
            this.spinner.hide();
            return
          }
          if (!res || res.status === 204 || res.length === 0) {
            this.invalidLink = true;
            this.errValue = false;
            this.refValue = null;
            this.spinner.hide();
            return;
          }
          this.errValue = false;
          this.invalidLink = false;
          this.refValue = res;
          console.log('this.refValue', this.refValue);
          this.spinner.hide();
        },
        error: (err: any) => {
          this.errValue = false;
          this.invalidLink = true;
          this.spinner.hide();
        }
      }
    )
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow only digits (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  allowAlphanumericOnly(event: KeyboardEvent) {
    const regex = /^[a-zA-Z0-9]+$/;
    const key = String.fromCharCode(event.charCode);
    if (!regex.test(key)) {
      event.preventDefault(); // block special characters
    }
  }

  callApiWithAdmNoAndMobile(admNo: string, mobile: string) {
    console.log('Calling API with:', admNo, mobile);
    const payload = {
      admNo: admNo,
      mobileNo: mobile,
      refId: this.refId
    };
    this.spinner.show();
    this.verification.getverfiystudent(payload).subscribe({
      next: (res: any) => {
        if (!res || res.status === 204 || res.length === 0) {
          this.toast.showError('Please Enter Valid Details');
          this.spinner.hide();
          return
        }
        this.studentdetials = res;
        this.studentname = res.StudentName;
        if (res.jwt.jsonV2.accessToken) {
          localStorage.setItem('studentToken', res.jwt.jsonV2.accessToken)
        }
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }

    }
    )
  }

  gethtticket(hallTicket:any){
   
    this.spinner.show()
    this.verification.getHtverication(hallTicket).subscribe({
      next:(res:any)=>{
        if(!res || res.status === 204 || res.length === 0){
          this.spinner.hide()
          this.hallTIcketerror=true;
          return ;
        }
        if(res){
          this.studentHallTicketName=res.studentName;
        this.saveButton = true;
        this.hallTIcketerror=false;
        this.spinner.hide()
        }
      },
      error:(err:any)=>{
        this.spinner.hide()
        this.hallTIcketerror=true;
      }
    })
  }

  savestudent() {
    if (!this.student.value.hallticketnumber || this.student.value.hallticketnumber.trim() === '') {
      this.toast.showError('Please Enter Valid Hall Ticket Number');
      return;
    }
    const payload = {
      "admNo": this.student.value.AdmNo,
      "refID": this.refId,
      "hallTicketNumber": this.student.value.hallticketnumber
    };
    console.log('payload', payload);
    this.spinner.show();
    this.verification.postHtNoverfication(payload).subscribe(
      {
        next: (res: any) => {
          if (!res || res.status === 204 || res.length === 0) {
            this.toast.showError('Hall Ticket Number Already Existed For Another Student.');
            this.spinner.hide();
            return
          }
          if(res){
            this.saveDetails = res;
          this.toast.showSuccess(this.saveDetails);
          this.student.reset();
          this.studentdetials = ''
          this.spinner.hide();
          this.saveButton=false;
          this.errValue=true;
          }
        },
        error: (err: any) => {
          this.spinner.hide();
          this.saveButton=false;
          this.errValue=false;
        }
      }
    )
  }

}

